import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Filter } from "./Filter";
import { Form } from "react-bootstrap";
// tslint:disable-next-line:no-submodule-imports
import { KSelect, KSELECT_BACKCOLOR, KSELECT_SIZE } from "../../../KSelect";
export class FixedSelectionFilter extends Filter {
    constructor(filterProperty, name, domain, multipleSelection = false) {
        super(filterProperty, name);
        this.domain = domain;
        this.multipleSelection = multipleSelection;
    }
    render(id, index, value) {
        var _a;
        const foundDomainElements = Array.isArray(value) ? this.domain.filter((d) => value.includes(d.value || "")) : this.domain.filter((d) => d.value === value);
        const idGen = `select-${this.name}-${Math.random() * 1000}`;
        return (_jsxs(Form.Group, { style: { margin: 3, marginRight: 10, fontSize: 10, display: "inline-flex" }, children: [_jsx(Form.Label, { column: true, style: { paddingTop: 0, paddingBottom: 0, position: "relative", top: 4 }, children: this.name }), _jsx(KSelect, { id: idGen, name: `filter-selector-${index}`, options: this.domain.concat([]), value: foundDomainElements === null || foundDomainElements === void 0 ? void 0 : foundDomainElements.map((d) => d.value || ""), multi: this.multipleSelection, clearable: true, backColor: KSELECT_BACKCOLOR.gray, size: KSELECT_SIZE.sm, 
                    // className="basic-single"
                    // classNamePrefix="basic-single"
                    onChange: (newValue) => {
                        this.onChange(this.filterProperty, newValue);
                    } }, !((_a = foundDomainElements[0]) === null || _a === void 0 ? void 0 : _a.value) ? idGen : undefined)] }, index));
    }
}
